module.exports = __webpack_public_path__ + "static/media/next_blue.5b123739.svg";